import { Controller } from "@hotwired/stimulus"
import Stimulus from "../../shared/utils/stimulus"

class DashboardInterestRates extends Controller {
  static targets = [`privatePanel`, `companyPanel`, `toggleLabel`]

  connect() {
    this.showingCompany = false

    // Grab hard references *before* moving: once the button leaves this
    // controller's element, Stimulus targets and actions no longer resolve.
    this.labelEl = this.toggleLabelTarget
    this.buttonEl = this.toggleLabelTarget.parentElement
    this.onToggleClick = this.toggle.bind(this)

    this.moveToggleToTargetIfApplicable()
  }

  disconnect() {
    if (!this.moved) return

    this.buttonEl.removeEventListener(`click`, this.onToggleClick)
    this.buttonEl.remove() // it lives outside our element, so clean it up ourselves
  }

  toggle(event) {
    event?.preventDefault()

    const dynamicHeadingEl = document.querySelector(
      `.js-interest-rate-dynamic-heading`
    )
    if (dynamicHeadingEl) {
      const interestForType = this.showingCompany ? `` : `företag`
      if (!interestForType) return

      dynamicHeadingEl.innerHTML = `Räntor på fasträntekonton: ${interestForType}`
    }

    this.showingCompany = !this.showingCompany

    this.privatePanelTarget.classList.toggle(`--hidden`, this.showingCompany)
    this.companyPanelTarget.classList.toggle(`--hidden`, !this.showingCompany)

    this.labelEl.textContent = this.showingCompany
      ? `Visa räntor - privat`
      : `Visa räntor - företag`

    this.moveToggleToTargetIfApplicable()
  }

  moveToggleToTargetIfApplicable() {
    const dataToggleTargetEl =
      this.element.querySelector(`[data-toggle-target]`)
    if (!dataToggleTargetEl) return

    const querySelector = dataToggleTargetEl.getAttribute(`data-toggle-target`)
    if (!querySelector) return

    const targetEl = document.querySelector(querySelector)
    if (!targetEl) return

    // Inherit the look of whatever button is already sitting in the slot.
    const existingButton = targetEl.querySelector(`button, a, [role='button']`)
    if (existingButton) {
      this.buttonEl.className = existingButton.className

      const existingLabel = existingButton.querySelector(`span, .label`)
      if (existingLabel) this.labelEl.className = existingLabel.className
    }

    targetEl.innerHTML = ``
    targetEl.appendChild(this.buttonEl)

    // data-action won't fire outside the controller's scope.
    this.buttonEl.addEventListener(`click`, this.onToggleClick)
    this.moved = true
  }
}

Stimulus.register(`dashboard-interest-rates`, DashboardInterestRates)
